import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/data-connector/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import CustomLoader from '../common/CustomLoader';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { prepareValidationForDirectus } from './common/common_utils';
import { SALESFORCE } from 'drapcode-constant';
import FormFieldWithLabel from '../common/FormFieldWithLabel';
import ParentCardNoHeader from '../common/ParentCardNoHeader';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
export class SalesForceDataSource extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  handleSendRequset = async (values) => {
    const { baseUrl, dataSourceName, userToken } = values;
    const { actions, match, history } = this.props;
    const { projectId, version } = match.params;
    await actions.getCollectionsForSalesforce({ projectId, version, baseUrl, userToken });

    if (this.props.dataConnector.salesforceCollections) {
      const collections = this.props.dataConnector.salesforceCollections;
      const { baseUrl, dataSourceName, userToken } = values;
      const { actions, match, history } = this.props;
      const { projectId, version } = match.params;
      const setting = {
        baseUrl,
        Authorization: `Bearer ${userToken}`,
      };

      const dataForSave = {
        name: dataSourceName,
        projectVersion: version,
        projectId,
        type: SALESFORCE,
        setting,
        completeData: {
          tables: collections,
        },
      };
      await actions.saveExternaldatabaseForSalesforce(dataForSave);
      const { externalDbUuid } = this.props.dataConnector;
      if (externalDbUuid) {
        history.push(
          `/2.0/data-connector/${version}/v/${projectId}/salesforce-datasource/${externalDbUuid}`,
        );
      }
    }
  };
  handleCancel = () => {
    const { match, history } = this.props;
    const { projectId, version } = match.params;
    history.push(`/2.0/collections/${version}/v/${projectId}/create`);
  };
  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />;
        </CommonPageComponent>
      );
    }
    const { dataConnector } = this.props;
    const { getCollectionsForSalesforcePending, saveExternaldatabaseForSalesforcePending } =
      dataConnector;
    return (
      <CommonPageComponent>
        <ParentContentCard title="Create Collection via Salesforce" datasourceIconSvg="Salesforce">
          <Formik
            initialValues={{
              dataSourceName: '',
              userToken: '',
              baseUrl: '',
            }}
            validationSchema={prepareValidationForDirectus}
            onSubmit={this.handleSendRequset}
          >
            {({ isSubmitting }) => (
              <Form>
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Name"
                    icon="text"
                    infoIcon={true}
                    infoDescription={
                      'Enter name for the Data Source you want to create in drapcode.'
                    }
                  >
                    <Field
                      type="text"
                      name="dataSourceName"
                      className="form-control form-control-sm"
                      placeholder="Data Source Name"
                    />
                    <ErrorMessage name="dataSourceName" component="p" className="text-danger" />
                  </FormFieldWithLabel>
                </div>

                <ParentCardNoHeader title="Salesforce Account Details">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Base URL"
                      icon="text"
                      infoIcon={true}
                      infoDescription={
                        'Enter Your Base Url. It acts as the endpoint for accessing and managing your database resources.'
                      }
                    >
                      <Field
                        type="text"
                        name="baseUrl"
                        className="form-control form-control-sm"
                        placeholder="BaseUrl eg.https://lcnc2-dev-ed.develop.my.salesforce.com"
                      />
                      <ErrorMessage name="baseUrl" component="p" className="text-danger" />
                    </FormFieldWithLabel>
                  </div>

                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Access Token"
                      icon="text"
                      infoIcon={true}
                      infoDescription={
                        'Enter SalesForce Token. This Token is necessary for your application to interact with the SalesForce backend services. Never share it publicly.'
                      }
                    >
                      <Field
                        type="text"
                        name="userToken"
                        className="form-control form-control-sm"
                        placeholder="Access Token"
                      />
                      <ErrorMessage name="userToken" component="p" className="text-danger" />
                    </FormFieldWithLabel>
                  </div>
                </ParentCardNoHeader>
                <div className="clearfix">
                  <button
                    className="btn btn-outline-secondary"
                    title="Cancel"
                    type="button"
                    onClick={this.handleCancel}
                  >
                    <i className="wb webconnect-times"></i> Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-theme-submit float-right"
                    disabled={
                      isSubmitting ||
                      getCollectionsForSalesforcePending ||
                      saveExternaldatabaseForSalesforcePending
                    }
                  >
                    <i className="wb webconnect-rocket"></i> &nbsp;Continue&nbsp;
                    <CustomLoader
                      loading={
                        getCollectionsForSalesforcePending ||
                        saveExternaldatabaseForSalesforcePending
                      }
                    ></CustomLoader>
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </ParentContentCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SalesForceDataSource);
